import React from 'react'

const FAVICON_DOMAIN_MAP = {
    'slack': 'slack.com',
    'microsoft-teams': 'teams.microsoft.com',
    'google-docs': 'docs.google.com',
    'google-sheets': 'sheets.google.com',
    'google-drive': 'drive.google.com',
    'notion': 'notion.so',
    'clickup': 'clickup.com',
    'monday': 'monday.com',
    'discord': 'discord.com',
    'linear': 'linear.app',
    'trello': 'trello.com',
    'asana': 'asana.com',
    'jira': 'atlassian.com',
    'github': 'github.com',
    'gitlab': 'gitlab.com',
}

const buildFaviconUrl = (domain) =>
    `https://www.google.com/s2/favicons?sz=64&domain_url=${domain}`

const ToolIcon = ({ type }) => {
    if (!type) return null

    if (typeof type === 'string' && /^https?:\/\//i.test(type)) {
        return (
            <img
                src={type}
                alt='Tool'
                className='w-[20px] h-[20px] rounded-sm'
            />
        )
    }

    switch (type) {
        case 'google':
            return (
                <img
                    src='https://img.logo.dev/google.com?token=pk_VAZ6tvAVQHCDwKeaNRVyjQ'
                    alt='Google'
                    className='w-[20px] h-[20px] '
                />
            )
        case 'drive':
            return (
                <img
                    src='https://img.logo.dev/salesforce.com?token=pk_VAZ6tvAVQHCDwKeaNRVyjQ'
                    alt='Google Drive'
                    className='w-[20px] h-[20px] '
                />
            )
        case 'sheets':
            return (
                <img
                    src='https://img.logo.dev/hubspot.com?token=pk_VAZ6tvAVQHCDwKeaNRVyjQ'
                    alt='Google Sheets'
                    className='w-[20px] h-[20px] '
                />
            )
        default: {
            const key = String(type).toLowerCase()
            const domain = FAVICON_DOMAIN_MAP[key]
            if (!domain) return null
            return (
                <img
                    src={buildFaviconUrl(domain)}
                    alt={key}
                    className='w-[20px] h-[20px] rounded-sm'
                />
            )
        }
    }
}

export default ToolIcon
